import { StatusContainer } from "./style";

interface IProps {
  status: string;
  width?: string;
}
export function StatusFornecedor({ status, width }: IProps) {
  const handleStatus = (status: string) => {
    if (status === "ATIVO") {
      return {
        backgroundColor: "#DBFFF6",
        color: "#10AC85",
        border: "1px solid #10AC85",
        texto: "Ativo",
      };
    }

    return {
      backgroundColor: "#FFFFFF01",
      color: "#B9B9B9",
      border: "1px solid #B9B9B9",
      texto: "Inativo",
    };
  };
  return (
    <StatusContainer width={width} style={handleStatus(status)}>
      {handleStatus(status).texto}
    </StatusContainer>
  );
}
